import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from 'src/app/modules/core/service/v2/abstractRepositoryV2';
import {PaymentRequestMovementModel} from "../../../api/entity/paymentRequestMovement.model";



@Injectable({providedIn: 'root'})
export class PaymentRequestMovementRepository extends AbstractRepositoryV2<PaymentRequestMovementModel>{
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('PaymentRequestMovement', serviceElementsFactory, injector);
    }
}
